import { createSlice } from '@reduxjs/toolkit'
import { generateEntitySlices } from 'Shared/sliceHelpers'

const surveySlice = createSlice({
  name: 'survey',
  initialState: {
    name: '',
    stats: null,
  },
  reducers: {
    upsert: (s, a) => ({ ...s, ...a.payload }),
  },
}).reducer

const entitySliceNames = ['questions', 'answers']

const reducers = {
  survey: surveySlice,
  ...generateEntitySlices(entitySliceNames)
}

export default reducers

